// ScriptId.js
// Purpose: Displays and manages a specific script's details, including copying code and handling domain-related actions.
// Logic: Uses React hooks and state to manage script data, handle modals, and integrate with navigation and location.

import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { socketService } from "../components/socketService";
import SuccessModal from "../components/SuccessModal";
import FailureModal from "../components/FailureModal";
import { toast } from "react-toastify";
import axios from "axios";
import Loader from "../components/Loader";
import TestScriptInfoPopup from "../components/TestScriptInfoPopup";
import { clog } from "../lib/utils";

function ScriptId() {
  const [htmlEmail, sethtmlEmail] = useState("html");
  const codeRef = useRef(null);
  const [copied, setCopied] = useState(false);
  // const [domainList, setDomainList] = useState({})
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { domainList } = state || {};
  const [openSuccessModal, setopenSuccessModal] = useState(undefined);
  const [openFailureModal, setopenFailureModal] = useState(undefined);
  const [successFailureMessage, setsuccessFailureMessage] = useState("");
  const [emailAdding, setemailAdding] = useState(false);
  const [email, setemail] = useState("");
  const [scriptCheckInfoPopup, setscriptCheckInfoPopup] = useState(false);
  // const scriptCheckFn = () => {
  //   let scriptDetected = false;
  //   let socketListenerAdded = false;

  //   let newwindow = window.open(
  //     `https://${domainList?.domain}?uid=${domainList?.uniq_token}`,
  //     Date.now(),
  //     "height=500,width=500"
  //   );

  //   if (window.focus) {
  //     newwindow.focus();
  //   }

  //   // Remove any existing listeners first
  //   socketService.off("website_script");

  //   const timeoutDuration = 30000;
  //   const scriptCheckTimeout = setTimeout(() => {
  //     if (!scriptDetected) {
  //       notify(
  //         "Script not detected on website. Please verify installation.",
  //         "error"
  //       );
  //       newwindow.close();
  //       if (socketListenerAdded) {
  //         socketService.off("website_script");
  //       }
  //     }
  //   }, timeoutDuration);

  //   // Setup socket listener before window loads
  //   socketListenerAdded = true;
  //   socketService.on("website_script", (data) => {
  //     if (scriptDetected) return; // Prevent multiple executions

  //     scriptDetected = true;
  //     clearTimeout(scriptCheckTimeout);

  //     clog("Socket connected for website_script", data);
  //     if (data?.type == "website_script" && data?.status == 2) {
  //       notify(data?.contents || "Script added successfully", "success");
  //       newwindow.close();
  //     } else if (data?.type == "website_script" && data?.status == 1) {
  //       notify(data?.contents || "Script not loaded.", "error");
  //       newwindow.close();
  //     }
  //   });

  //   newwindow.onclose = () => {
  //     clearTimeout(scriptCheckTimeout);
  //     clog("New window closed");
  //     if (socketListenerAdded) {
  //       socketService.off("website_script");
  //     }
  //   };
  // };

  //scriptCheckFn is a function that checks if a script is installed on a website by opening a new window and listening for socket events.
  const scriptCheckFn = () => {
    let scriptDetected = false;
    let socketListenerAdded = false;
    let timeoutId = null;

    let newwindow = window.open(
      `https://${domainList?.domain}?uid=${
        domainList?.uniq_token
      }&login_user_id=${
        JSON?.parse(localStorage?.getItem("login_data"))?.resp_user?.id
      }`,
      Date.now(),
      "height=500,width=500"
    );

    if (window.focus) {
      newwindow.focus();
    }

    // Remove any existing listeners first
    socketService.off("website_script");

    const cleanup = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (socketListenerAdded) {
        socketService.off("website_script");
      }
      clog("Cleanup completed");
    };

    // Check if window was closed
    const checkWindow = setInterval(() => {
      if (newwindow.closed) {
        cleanup();
        clearInterval(checkWindow);
        clog("Window was closed by user");
      }
    }, 1000);

    timeoutId = setTimeout(() => {
      if (!scriptDetected) {
        notify(
          "We couldn't locate the script on your website. Please verify that it has been installed correctly.",
          "error"
        );
        newwindow.close();
        cleanup();
        clearInterval(checkWindow);
      }
    }, 30000);

    // Setup socket listener before window loads
    socketListenerAdded = true;
    socketService.on("website_script", (data) => {
      if (scriptDetected) return; // Prevent multiple executions

      scriptDetected = true;
      cleanup();
      clearInterval(checkWindow);

      clog("Socket connected for website_script", data);
      if (data?.type == "website_script" && data?.status == 2) {
        notify(data?.contents || "Script added successfully", "success");
        newwindow.close();
      } else if (data?.type == "website_script" && data?.status == 1) {
        notify(data?.contents || "Script not loaded.", "error");
        newwindow.close();
      }
    });

    newwindow.onbeforeunload = () => {
      cleanup();
      clearInterval(checkWindow);
    };
  };
  const removeModal = () => {
    setopenSuccessModal(undefined);
    setopenFailureModal(undefined);
  };
  // clog("domainList", domainList);
  const scriptCode = `
  <script>
    (function() {
      var script = document.createElement('script');
      var userId = "vsn-${
        JSON.parse(localStorage.getItem("login_data"))?.resp_user?.id
      }";
      script.src = "${
        process.env.REACT_APP_PIXEL_SCRIPT
      }?id=" + encodeURIComponent(userId);
      script.async = true;
      document.head.appendChild(script);
    })();
  </script>`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(scriptCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  const [activeToasts, setActiveToasts] = useState(new Set());
  //sendEmail is a function that sends an email with the script code to a specified email address.
  const sendEmail = async (e) => {
    e.preventDefault();
    if (!email) {
      notify("Please enter email address", "error");
      return;
    }
    setemailAdding(true);
    try {
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/analytic/script_email`,
        method: "POST",
        data: {
          email: email,
          analytic_script: scriptCode,
        },
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
      });
      if (!response.data.error) {
        setemailAdding(false);
        setemail("");
        setTimeout(() => {
          notify(response?.data?.message, "success");
        }, 200);
      } else {
        clog("Error in fetching notifications");
        setemailAdding(false);
        // setopenFailureModal("dismissible");
        // setsuccessFailureMessage(response.message);
        notify(response?.data?.message, "error");
      }
    } catch (error) {
      clog("Error in fetching notifications", error);
      setemailAdding(false);
      notify(error?.response?.data?.message || error?.message, "error");
    }
  };
  //notify is a function that displays a toast notification with a message and type, ensuring that duplicate notifications are not shown.
  const notify = (message, type) => {
    const toastKey = `${message}-${type}`;
    if (activeToasts.has(toastKey)) {
      return;
    }

    setActiveToasts((prev) => new Set([...prev, toastKey]));
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      type: type || "default",
      onClose: () => {
        setActiveToasts((prev) => {
          const newSet = new Set(prev);
          newSet.delete(toastKey);
          return newSet;
        });
      },
    });
  };
  //useEffect to fetch initial domain list when component mounts
  useEffect(() => {
    if (!socketService.isConnected()) {
      socketService.initialize();
    }
    // clog("Socket connected for website_script");
    // socketService.on("website_script", (data) => {
    //   clog('Socket connected for website_script',data);
    // })

    return () => {
      socketService.off("website_script", () => {
        clog("Socket disconnected");
      });
    };
  }, []);

  return (
    <>
      <div
        className="text-[20px] font-[600] mb-4 flex items-center cursor-pointer gap-2"
        onClick={() => navigate("/script")}
      >
        <svg className="icon text-[20px]">
          <use href="#icon_backarrow"></use>
        </svg>{" "}
        Back to Domain List
      </div>
      <div className="flex justify-center items-center">
        <div className="grid grid-cols-3 gap-4">
          <div
            className={
              htmlEmail === "html"
                ? "w-full bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] text-transparent bg-clip-text text-[20px] text-center rounded-lg font-bold cursor-pointer"
                : "w-full text-center rounded-lg font-bold text-[20px] cursor-pointer"
            }
            onClick={() => sethtmlEmail("html")}
          >
            View HTML code
          </div>
          <div
            className={
              htmlEmail === "email"
                ? "w-full bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] text-transparent bg-clip-text text-[20px] text-center rounded-lg font-bold cursor-pointer"
                : "w-full text-center rounded-lg font-bold text-[20px] cursor-pointer"
            }
            onClick={() => sethtmlEmail("email")}
          >
            Send script via email
          </div>
          <div
            className={
              htmlEmail === "guide"
                ? "w-full bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] text-transparent bg-clip-text text-[20px] text-center rounded-lg font-bold cursor-pointer"
                : "w-full text-center rounded-lg font-bold text-[20px] cursor-pointer"
            }
            onClick={() => sethtmlEmail("guide")}
          >
            Installation Guide
          </div>
        </div>
      </div>
      {htmlEmail === "html" && (
        <div className="border rounded-[18px] shadow-md bg-white mb-4 mt-8">
          <div className="flex items-center p-4 text-[18px] font-[600] border-b border-[#E9EBF0]">
            Installing script with HTML code
          </div>

          <div className="p-4">
            <h5 className="text-[18px] font-[600] mb-4">
              1. Copy the tracking script
            </h5>

            <div className="bg-[#2A2A2A] p-4 text-white mb-4">
              <pre className="p-3 rounded-md overflow-auto">
                <code ref={codeRef}>{scriptCode}</code>
              </pre>
              <button
                type="button"
                className="bg-white p-2 text-black w-full text-[18px] font-[600] mt-4 hover:text-[#F14CE2] rounded-md"
                onClick={copyToClipboard}
              >
                <svg className="icon me-3">
                  <use href="#icon_copy"></use>
                </svg>
                {copied ? "Copied!" : "Copy Code"}
              </button>
            </div>

            <h5 className="text-[18px] font-[600] mb-4">
              2. Login to website and paste code
            </h5>

            <div className="px-4 mb-4">
              <p className="text-[#2A2A2A]">
                Paste the code into header of your website. You can even install
                the script via Google Tag Manager.{" "}
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    sethtmlEmail("guide");
                  }}
                  className="text-[#5E78F4] cursor-pointer"
                >
                  View Installation Guide
                </a>
              </p>
            </div>

            <h5 className="text-[18px] font-[600] mb-4">3. Test Script</h5>

            <div className="px-4 mb-4">
              <p className="text-[#2A2A2A]">
                This test verifies that the script is active and functioning
                correctly by opening a window to your website. If the tracker is
                properly installed, the popup will close automatically, and a
                success message will appear.
              </p>
            </div>

            <button
              onClick={() => {
                setscriptCheckInfoPopup(true);
              }}
              disabled={!domainList?.domain || !domainList?.uniq_token}
              type="default"
              className=" disabled:cursor-not-allowed py-2 max-w-[220px] w-full me-6 rounded-[20px] font-semibold text-[18px] ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-white hover:transition hover:delay-75"
            >
              {"</>"} Test Script
            </button>
          </div>
        </div>
      )}
      {/* email code section */}
      {htmlEmail === "email" && (
        <div className="border rounded-[18px] shadow-md bg-white mb-4 mt-8">
          <form onSubmit={sendEmail}>
            <div className="flex items-center p-4 text-[18px] font-[600] border-b border-[#E9EBF0]">
              Email script to teammate
            </div>

            <div className="p-4">
              <h5 className="text-[18px] font-[600] mb-4">
                Please enter teammate email address
              </h5>

              <input
                type="email"
                placeholder="Enter teammate email address"
                value={email}
                onChange={(e) => setemail(e.target.value)}
                className="border rounded-full p-2 w-full mb-4"
                pattern="[^@\s]+@[^@\s]+\.[^@\s]+" // Email validation
              />
              <h5 className="text-[18px] font-[600] mb-4">Email message</h5>
              <div className="border rounded-[18px] shadow-md p-4 mb-2">
                <div>
                  Could you help me install vison.ai on our website?
                  <br />
                  Just paste the JavaScript snippet into the website&apos;s
                  header.
                </div>
                <div className="bg-[#2A2A2A] text-white mb-4 mt-2">
                  <pre className="p-3 rounded-md overflow-auto">
                    <code ref={codeRef}>{scriptCode}</code>
                  </pre>
                </div>
              </div>

              <button
                type="submit"
                className="py-2 max-w-[220px] w-full me-6 rounded-[20px] font-semibold text-[18px] ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-white hover:transition hover:delay-75"
              >
                {emailAdding ? (
                  <div className="flex justify-center items-center">
                    <Loader />
                  </div>
                ) : (
                  <>
                    <span>
                      <svg className="icon me-3">
                        <use href="#icon_arrowemail"></use>
                      </svg>
                    </span>{" "}
                    Send Email
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      )}
      {/* Installation Guide section */}
      {htmlEmail === "guide" && (
        <div className="border rounded-[18px] shadow-md bg-white mb-4 mt-8">
          <div className="flex items-center p-4 text-[18px] font-[600] border-b border-[#E9EBF0]">
            Kwin Script Installation Guide
(WordPress & Google Tag Manager)
          </div>

          <div className="p-4">
            {/* Intro */}
            <p className="text-[#2A2A2A] mb-6">
              This guide will help you install the Kwin tracking script on your website in a simple and correct way.
            </p>
            <div className="px-4 mb-6 border border-[#E9EBF0] rounded-[12px] p-4">

            <p className="text-[#2A2A2A]">
              There are two recommended methods:
            </p>
            <ul className="list-disc ml-5 text-[15px] text-[#2A2A2A] mb-6 space-y-1">
              <li>Install directly in WordPress (recommended for beginners)</li>
              <li>
                Install using Google Tag Manager (recommended if you already use GTM)
              </li>
            </ul>
            </div>

            {/* Step 1 – WordPress */}
            <h5 className="text-[18px] font-[600] mb-3">
              Method 1: Install Kwin Script in WordPress
            </h5>
            <img
              src="/images/installation-guide/step1-wordpress.png"
              alt="WordPress Theme File Editor"
              className="rounded-[12px] mb-4 w-full max-w-[560px]"
            />
            <div className="px-4 mb-6 border border-[#E9EBF0] rounded-[12px] p-4">
              <ul className="list-disc ml-5 text-[15px] text-[#2A2A2A] space-y-1">
                <li>Log in to your WordPress dashboard</li>
                <li>Go to Appearance → Theme File Editor</li>
                <li>Open the file named <code className="bg-[#F5F5F5] px-1 rounded">header.php</code></li>
                <li>Find the closing <code className="bg-[#F5F5F5] px-1 rounded">&lt;/head&gt;</code> tag</li>
                <li>Paste the Kwin script just before <code className="bg-[#F5F5F5] px-1 rounded">&lt;/head&gt;</code></li>
                <li>Click Save</li>
              </ul>
              <p className="text-[#2A2A2A] text-[15px] mt-3">
                Done! The script is now installed on your entire website.
              </p>
            </div>

            {/* Step 2 – No-code plugin */}
            <h5 className="text-[18px] font-[600] mb-3">
              Alternative (No Coding Method)
            </h5>
            <img
              src="/images/installation-guide/step2-wpcode.png"
              alt="WPCode plugin – Insert Headers and Footers"
              className="rounded-[12px] mb-4 w-full max-w-[560px]"
            />
            <div className="px-4 mb-6 border border-[#E9EBF0] rounded-[12px] p-4">
              <p className="text-[#2A2A2A] text-[15px] mb-2">
                If you are not comfortable editing code:
              </p>
              <ol className="list-decimal ml-5 text-[15px] text-[#2A2A2A] space-y-1">
                <li>
                  Install a plugin like{" "}
                  <span className="font-[600] text-[#2A2A2A]">
                    WPCode – Insert Headers and Footers
                  </span>
                </li>
                <li>Go to the plugin settings</li>
                <li>Paste the Kwin script in the Header section</li>
                <li>Save changes</li>
              </ol>
            </div>

            {/* Step 3 – GTM */}
            <h5 className="text-[18px] font-[600] mb-3">
              Method 2: Install via Google Tag Manager
            </h5>
            <img
              src="/images/installation-guide/step3-gtm.png"
              alt="Google Tag Manager – Custom HTML tag setup"
              className="rounded-[12px] mb-4 w-full max-w-[560px]"
            />
            <div className="px-4 mb-6 border border-[#E9EBF0] rounded-[12px] p-4">
              <ul className="list-disc ml-5 text-[15px] text-[#2A2A2A] space-y-1">
                <li> Log in to Google Tag Manager</li>
                <li>
                  Click <span className="font-[600] text-[#2A2A2A]">Tags</span>{" "}
                  → <span className="font-[600] text-[#2A2A2A]">New</span>
                </li>
                <li>Name it "Kwin Script"</li>
                <li>
                  Choose{" "}
                  <span className="font-[600] text-[#2A2A2A]">Custom HTML</span>
                </li>
                <li>Paste the Kwin script</li>
                <li>
                  Set trigger to{" "}
                  <span className="font-[600] text-[#2A2A2A]">All Pages</span>
                </li>
                <li>Save and Publish</li>
              </ul>
            </div>

            {/* Step 4 – Test */}
            <h5 className="text-[18px] font-[600] mb-3">Test the Script</h5>
            <div className="px-4 mb-6 border border-[#E9EBF0] rounded-[12px] p-4">
            <img
              src="/images/installation-guide/step4-unverified.png"
              alt="Domain status – Unverified with Test Script button"
              className="rounded-[12px] mb-4 w-full max-w-[560px]"
            />
              <ul className="list-disc ml-5 text-[15px] text-[#2A2A2A] space-y-2">
                <li>
                  After installing, your domain status will show as{" "}
                  <span className="font-[600] text-[#2A2A2A]">Unverified</span>
                </li>
                <li>
                  Click the{" "}
                  <span className="font-[600] text-[#2A2A2A]">Test Script</span>{" "}
                  button on the{" "}
                  <span className="font-[600] text-[#2A2A2A]">View HTML code</span>{" "}
                  tab
                </li>
                <li>Your website will open in a pop-up window</li>
              </ul>
              <img
                src="/images/installation-guide/step4-popup.png"
                alt="Test Script confirmation popup"
                className="rounded-[12px] my-4 w-full max-w-[560px]"
              />
              <ul className="list-disc ml-5 text-[15px] text-[#2A2A2A] space-y-2">
                <li>
                  Once verified, a success message will appear and the domain
                  status changes to{" "}
                  <span className="font-[600] text-[#2A2A2A]">Verified</span>
                </li>
              </ul>
              <img
                src="/images/installation-guide/step4-verified.png"
                alt="Domain status – Verified"
                className="rounded-[12px] mt-4 w-full max-w-[560px]"
              />
            </div>

            {/* Step 5 – Page control */}
            <h5 className="text-[18px] font-[600] mb-3">
              How to Control Pages in Kwin
            </h5>
            <img
              src="/images/installation-guide/step5-pages.png"
              alt="Pixel page – adding tracked URLs"
              className="rounded-[12px] mb-4 w-full max-w-[560px]"
            />
            <div className="px-4 mb-6 border border-[#E9EBF0] rounded-[12px] p-4">
              <p className="text-[#2A2A2A] text-[15px] mb-2">
                After installing the script globally:
              </p>
              <ul className="list-disc ml-5 text-[15px] text-[#2A2A2A] space-y-1">
                <li>Log in to the Kwin dashboard</li>
                <li>Go to the Pixel page</li>
                <li>Add the page URLs where you want Kwin to run</li>
                <li>
                  Example:
                 <br /> <b>/pricing</b>
                 <br /> <b>/demo</b>
                 <br /> <b>/contact</b>
                </li>
              </ul>
              <p className="text-[#2A2A2A] text-[15px] mt-3">
                Kwin will only run on these pages even though the script is installed everywhere
              </p>
            </div>

            {/* Step 6 – Redirects */}
            <h5 className="text-[18px] font-[600] mb-3">
              Handling URL Changes (301 Redirects)
            </h5>
            <div className="px-4 mb-4 border border-[#E9EBF0] rounded-[12px] p-4">
              <p className="text-[#2A2A2A] text-[15px] mb-2">
                If your page URL changes: <br/> Example:
              </p>
              <div className="bg-[#F5F5F5] p-3 rounded-[8px] text-[14px] text-[#2A2A2A] mb-3">
                /old-page → redirects to → /new-page
              </div>
              <p className="text-[#2A2A2A] text-[15px]">
                Simply add the new URL inside Kwin:
              </p>
              <div className="bg-[#F5F5F5] p-3 rounded-[8px] text-[14px] text-[#2A2A2A] mb-3">
                  /new-page
              </div>
              <p className="text-[#2A2A2A] text-[15px]">
                Kwin will automatically start tracking the new page.              </p>
            </div>
          </div>
        </div>
      )}
      <SuccessModal
        open={openSuccessModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
      <FailureModal
        open={openFailureModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
      <TestScriptInfoPopup
        scriptCheckInfoPopup={scriptCheckInfoPopup}
        setscriptCheckInfoPopup={setscriptCheckInfoPopup}
        scriptCheckFn={scriptCheckFn}
      />
    </>
  );
}

export default ScriptId;
